import { t } from "@/i18n-js/instance";
import { DataTable } from "@circle-react-shared/uikit/DataTableV2";
import { Typography } from "@circle-react-uikit/Typography";
import { AddPriceButton } from "../AddPriceButton";
import { usePricingTabContext } from "../hooks/usePricingTabContext";
import { PricingTabPriceListCellActions } from "./CellActions";
import { PricingTabPriceListCellPaymentType } from "./CellPaymentType";
import { PricingTabPriceListCellPricing } from "./CellPricing";

const columns = [
  {
    accessorKey: "paymentType",
    header: t(
      "settings.paywalls.modal.tabs.pricing.table.columns.payment_type",
    ),
    cell: (props: any) => <PricingTabPriceListCellPaymentType {...props} />,
  },
  {
    accessorKey: "pricing",
    header: t("settings.paywalls.modal.tabs.pricing.table.columns.pricing"),
    cell: (props: any) => <PricingTabPriceListCellPricing {...props} />,
  },
  {
    accessorKey: "actions",
    header: " ",
    cell: (props: any) => <PricingTabPriceListCellActions {...props} />,
  },
];

export const PricingTabPriceList = () => {
  const { getActivePrices } = usePricingTabContext();
  const prices = getActivePrices();

  return (
    <div className="flex flex-col gap-y-4">
      <div className="grid grid-cols-6 gap-x-8">
        <div className="col-span-4">
          <Typography.LabelLg weight="semibold">
            {t("settings.paywalls.modal.tabs.pricing.pricing_title")}
          </Typography.LabelLg>
          <Typography.BodyMd color="text-default">
            {t("settings.paywalls.modal.tabs.pricing.description")}
          </Typography.BodyMd>
        </div>
        <div className="col-span-2 flex justify-end">
          <AddPriceButton variant="secondary" />
        </div>
      </div>
      <DataTable columns={columns} data={prices}>
        <DataTable.Table>
          <DataTable.Header />
          <DataTable.Body />
        </DataTable.Table>
      </DataTable>
    </div>
  );
};
